import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { InputNumber } from 'primereact/inputnumber';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';

import api from './../../service/api';
import { formatCurrency } from './../../service/format';
import InputDecimal from '../../components/InputDecimal';
const Route = () => {
    let emptyRoute = {
        description: '',
        distance: null,
        total_tolls: null
    };

    const [routes, setRoutes] = useState([]);
    const [routeDialog, setRouteDialog] = useState(false);
    const [deleteRouteDialog, setDeleteRouteDialog] = useState(false);
    const [route, setRoute] = useState(emptyRoute);
    const [submitted, setSubmitted] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);
    const toast = useRef(null);
    const dt = useRef(null);

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _route = { ...route };
        _route[`${name}`] = val;

        setRoute(_route);
    }

    const openNew = () => {
        setRoute(emptyRoute);
        setSubmitted(false);
        setRouteDialog(true);
        setDisabled(false);
    }

    const hideDialog = () => {
        setSubmitted(false);
        setRouteDialog(false);
        setDisabled(false);
    }

    const hideDeleteRouteDialog = () => {
        setDeleteRouteDialog(false);
    }
    

    const editRoute = (route) => {
        setRoute({ ...route });
        setRouteDialog(true);
    }

    const confirmDeleteRoute = (route) => {
        setRoute({ ...route });
        setDeleteRouteDialog(true);
    }

    const handleRoute = () => {
        if(!route.description)
            return setSubmitted(true);
        
        setSubmitted(false);
        setDisabled(true);
        var uri = route.code ? '/route/update' : '/route/create';
        api().post(uri, route).then(response => {
            if(response.status === 200 && response.data.result){
                toast.current.show({severity: 'success', summary: 'Sucesso', detail: response.data.message});
                listRoutes();
                hideDialog();
            } else {
                toast.current.show({severity: 'warn', summary: 'Atenção', detail: response.data.message});
                setDisabled(false);
            }
        });
    }

    const handleDeleteRoute = () => {
        setDeleteRouteDialog(false);
        api().delete('/route/' + route.code).then(response => {
            if(response.status === 200 && response.data.result) {
                toast.current.show({severity: 'success', summary: 'Sucesso', detail: response.data.message});
                listRoutes();
            } else toast.current.show({severity: 'error', summary: 'Erro', detail: response.data.message});
            setRoute(emptyRoute);
        });
    }

    const listRoutes = () => {
        api().get('/route/list').then(response => {
            if(response.status === 200 && response.data.result){
                setRoutes(response.data.data);
            }
        });
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="Nova" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>
        )
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <Button icon="pi pi-trash" className="p-button-rounded p-button-danger mt-2 mr-2" onClick={() => confirmDeleteRoute(rowData)} />
                <Button icon="pi pi-ellipsis-v" className="p-button-rounded p-button-info" onClick={() => editRoute(rowData)} />
            </div>
        );
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Gerenciar Rotas</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Pesquisar..." />
            </span>
        </div>
    );

    const productDialogFooter = (
        <>
            <Button label="Cancelar" disabled={disabled} icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label="Salvar" onClick={handleRoute} loading={disabled} icon="pi pi-check" className="p-button-text"  />
        </>
    );
    const deleteRouteDialogFooter = (
        <>
            <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={hideDeleteRouteDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text" onClick={handleDeleteRoute} />
        </>
    );

    useEffect(() => {
        listRoutes();
    }, []);
  
    return (
        <div className="grid crud-demo">
            <div className="col-12">
                <div className="card">
                    <Toast ref={toast} />
                    <Toolbar className="mb-4" left={leftToolbarTemplate}></Toolbar>

                    <DataTable ref={dt} value={routes} 
                        dataKey="id" paginator rows={10} rowsPerPageOptions={[5, 10, 25]} className="datatable-responsive"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Listando {first} a {last} de {totalRecords} registros"
                        globalFilter={globalFilter} emptyMessage="Nenhum registro encontrado." header={header} responsiveLayout="scroll">
                        <Column field="description"  header="Descrição" sortable headerStyle={{ width: '24%', minWidth: '10rem' }}></Column>
                        <Column body={rowData => (rowData.distance || 0) ? (formatCurrency(rowData.distance)) : '-'} header="Distância (Km)" sortable></Column>
                        <Column body={rowData => (rowData.total_tolls || 0) ? (formatCurrency(rowData.total_tolls, true)) : '-'} header="Valor Total de Pedágios" sortable></Column>
                        <Column body={actionBodyTemplate}></Column>
                    </DataTable>

                    <Dialog visible={routeDialog} style={{ width: '450px' }} header="Rota" modal className="p-fluid" footer={productDialogFooter} onHide={hideDialog}>
                    
                        <div className="field">
                            <label htmlFor="description">Descrição</label>
                            <InputText disabled={disabled} autoComplete='Rotas' id="description" value={route.description} onChange={(e) => onInputChange(e, 'description')} required />
                            {submitted && !route.description && <small className="p-invalid p-error">A descrição é obrigatória.</small>}
                        </div>

                        <div className="formgrid grid">
                            <div className="field col">
                                <label htmlFor="distance">Distância (Km)</label>
                                <InputNumber disabled={disabled} id="distance" currency='BRL' minFractionDigits={0} mode='decimal' value={route.distance} onValueChange={(e) => onInputChange(e, 'distance')}  />
                            </div>
                        </div>

                        <div className="field">
                            <label htmlFor='tolls'>Valor Total de Pedágios</label>
                            <InputDecimal disabled={disabled} id="tolls" mode='currency' value={route.total_tolls} onChange={(e) => onInputChange(e, 'total_tolls')}  />
                        </div>
                    </Dialog>

                    <Dialog visible={deleteRouteDialog} style={{ width: '450px' }} header="Atenção" modal footer={deleteRouteDialogFooter} onHide={hideDeleteRouteDialog}>
                        <div className="flex align-items-center justify-content-center">
                            <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                            {route && <span>Você tem certeza que deseja remover esta rota?</span>}
                        </div>
                    </Dialog>
                    
                </div>
            </div>
        </div>
    );
}

export default Route;